@if (hasSelectedTenant()) {
  <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="mat-accent">
    @for (link of tabLinks; track link) {
      <a mat-tab-link [attr.data-qa-id]="'tenant-nav-tab-' + link.route" [routerLink]="link.route" routerLinkActive #rla="routerLinkActive" [active]="rla.isActive">
        {{link.label}}
      </a>
    }
  </nav>
}
<mat-tab-nav-panel #tabPanel>
  <router-outlet></router-outlet>
</mat-tab-nav-panel>
